(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-readmore="true"]').forEach(function(el) {
    var btn = el.closest('.mantemi-readmore-wrapper')?.querySelector('.mantemi-readmore-btn');
    if (!btn) return;

    // Hide button if content fits without truncation
    if (el.scrollHeight <= el.clientHeight + 2) {
      btn.style.display = 'none';
      el.closest('.mantemi-readmore-wrapper').classList.add('no-fade');
      return;
    }

    btn.addEventListener('click', function() {
      var expanded = el.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded);
      btn.querySelector('.mantemi-readmore-icon').style.transform = expanded ? 'rotate(180deg)' : '';
      if (expanded) {
        btn.firstChild.textContent = 'Διαβάστε λιγότερα ';
      } else {
        btn.firstChild.textContent = btn.getAttribute('data-label') || 'Διαβάστε περισσότερα ';
      }
    });

    btn.setAttribute('data-label', btn.firstChild.textContent);
  });
  } catch(e) { console.error(e); }
})();

})();
